import { setRenewalOfferPreference } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { ISuccessResponse } from '@/interfaces/make-a-payment/make-a-payment.interface';
import { IUpdateRenewalOfferRequest } from '@/interfaces/insurance/renewal.interface';

export const InsuranceService = {
  /**
   * Set Auto Renew preference
   *
   * @param formData
   */
  setRenewalOfferPreference(request: IUpdateRenewalOfferRequest): Promise<ISuccessResponse> {
    return _http.HttpPut(setRenewalOfferPreference, request);
  },
};
